import React from "react";

export default function SubmitIcon(props?: any) {
  // Calculate rotation directly from props to avoid initial animation
  const getRotation = () => {
    if (props.direction === "up") {
      return "rotate(0deg)";
    }
    if (props.direction === "straight_down") {
      return "rotate(135deg)";
    }
    // default to "down"
    return "rotate(180deg)";
  };

  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
    transform: getRotation()
  };

  const filteredStyles = Object.keys(svgStyles)
  .filter(key => svgStyles[key] !== null && svgStyles[key] !== undefined)
  .reduce((acc: any, key) => {
    acc[key] = svgStyles[key];
    return acc;
  }, {});

  return (
    <svg
      viewBox="0 0 12 12"
      fill="none" 
      style={{...filteredStyles, fill : "none"}}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
      <path d="M0.217705 11.7823C0.362866 11.9274 0.553127 12 0.743388 12C0.933648 12 1.12391 11.9274 1.26902 11.7823L10.5132 2.5381V6C10.5132 6.41055 10.846 6.7434 11.2566 6.7434C11.6672 6.7434 12 6.41055 12 6V0.743396C12 0.332843 11.6672 0 11.2566 0H6.00002C5.58946 0 5.25662 0.332843 5.25662 0.743396C5.25662 1.15395 5.58946 1.48679 6.00002 1.48679H9.46183L0.217705 10.731C-0.0725682 11.0213 -0.0725682 11.492 0.217705 11.7823Z" fill={filteredStyles.fill || "#FFF"}/>
      </g>
    </svg>
  );
}